<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="YongHuList" data-title="用户管理">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="flex-1 overflow-hidden flex gap-x-3 mt-2">
      <c_bumen
        @node-change="
          (id) => {
            state.params.department_id = id;
            onLoad();
          }
        "
      />
      <div class="content">
        <el-table
          :data="state.tableData"
          v-loading="!Array.isArray(state.tableData)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column
            fixed
            label="#"
            width="70"
            type="index"
            :index="
              (index) =>
                $buildTabIndex(state.params.page, state.params.limit, index)
            "
            align="center"
          />
          <el-table-column :width="140">
            <template #header>
              <div class="c-table-col-header" label1="姓名" label2="性别" />
            </template>
            <template #default="{ row }">
              <div class="flex items-center gap-x-1">
                <strong>{{ row.name }}</strong>
                <el-icon v-if="row.sex == '男'"
                  ><Male color="#1e90ff"
                /></el-icon>
                <el-icon v-else style="transform: rotate(180deg)"
                  ><Male color="#f00"
                /></el-icon>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="所属部门"
            prop="department_name"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="手机号"
            prop="phone"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="角色"
            prop="admin_role_name"
            :formatter="$tab_TextFormat"
          />
          <el-table-column
            label="职务"
            prop="job"
            :formatter="$tab_TextFormat"
          />
          <el-table-column label="管理员" align="center">
            <template #default="{ row }">
              <text v-if="row.is_super_auth" class="text-green-600">是</text>
              <text v-else class="text-red-600">否</text>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template #default="{ row }">
              <el-switch
                v-model="row.status"
                active-text="启用"
                inactive-text="禁用"
                :active-value="1"
                :inactive-value="0"
                :disabled="!row.id"
                inline-prompt
                @change="onUpdateStatus($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
            :width="260"
          >
            <template #default="{ row }">
              <el-button
                type="warning"
                :icon="Edit"
                link
                @click="
                  state.selectId = row.id;
                  state.showInfo = true;
                "
                >编辑
              </el-button>
              <el-button
                type="warning"
                :icon="Connection"
                link
                @click="onResetPassword(row)"
                >重置密码
              </el-button>
              <el-button
                type="danger"
                :icon="Delete"
                link
                @click="onDelete(row)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <c_page
          :total="state.totalCount"
          :pageIndex="state.params.page"
          :pageSize="state.params.limit"
          @onLoad="
            (page) => {
              state.params.page = page.pageIndex;
              state.params.limit = page.pageSize;
              onLoad();
            }
          "
        />
      </div>
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑用户' : '新建用户'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      @close="
        state.showInfo = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  admin_delete,
  admin_page,
  admin_updateStatus,
  admin_resetPassword,
} from "@/http/admin";
import { ElMessageBox } from "element-plus";
import { onDeleteConfirm, post_response } from "@/utils/funcs";

import c_bumen from "../BuMen/Index.vue";
import c_info from "./Info.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_bumen,
    c_info,
  },
  setup(props) {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      admin_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(admin_delete, row.id, onLoad, {
        filed: "用户",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }用户<strong style="font-weight:bold;color:#000">${
          row.name
        }</strong>的账号吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          admin_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    const onResetPassword = (row) => {
      ElMessageBox.confirm(
        `您确定<strong style="color: var(--el-color-warning);">重置</strong>用户<strong style="font-weight:bold;color:#000">${row.name}</strong>的密码吗？`,
        "重置密码",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        admin_resetPassword({
          id: row.id,
        }).then((res) => {
          post_response(res, onLoad);
        });
      });
    };

    return { state, onLoad, onDelete, onUpdateStatus, onResetPassword };
  },
};
</script>

<style lang="scss" scoped></style>
